import { Slider } from "@/components/ui/slider.tsx";
import { ONLY_NUMERIC_REGEX } from "@/constants/regex";

type SliderInputProps = {
  valueSlider: number[];
  /** Fires on every drag step and keyboard step. The consumer decides when to
   * commit (e.g. debounced), so there's no separate commit callback. */
  onChangeSlider?: (value: number[]) => void;
  valueInput: number;
  /** Fires on every keystroke/step. The consumer decides when to commit (e.g.
   * debounced), so there's no separate commit callback. */
  onChangeInput?: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
};

export default function SliderInput(props: Readonly<SliderInputProps>) {
  const {
    valueSlider,
    onChangeSlider,
    valueInput,
    onChangeInput,
    min = 0,
    max = 100,
    disabled
  } = props;

  return (
    <div className="flex flex-row w-full gap-2 flex-1">
      <Slider
        value={valueSlider}
        onValueChange={onChangeSlider}
        min={min}
        max={max}
        step={1}
        className="w-full"
        disabled={disabled}
      />
      <input
        type="text"
        inputMode="numeric"
        value={valueInput}
        onChange={(e) => {
          const value = e.target.value.replace(ONLY_NUMERIC_REGEX, "");
          onChangeInput?.(Number(value));
        }}
        onKeyDown={(e) => {
          if (e.key === "ArrowUp" && valueInput < max) {
            onChangeInput?.(valueInput + 1);
          } else if (e.key === "ArrowDown" && valueInput > min) {
            onChangeInput?.(valueInput - 1);
          }
        }}
        className="flex-grow-0 flex-shrink-1 w-[44px] text-center py-0.5 px-2 border border-gainsboro rounded-md [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none disabled:bg-white-smoke disabled:text-light-gray"
        disabled={disabled}
      />
    </div>
  );
}
